// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__nOHj2","navText":"Navbar_navText__2ZZEs","navLogo":"Navbar_navLogo__3mHZC","imgLogo":"Navbar_imgLogo__3K5k6"};